/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Tool_Executing_SqlInputs */



/**
* | output |
* | --- |
* | "Analyzing data" |
*
* @param {Chat_Tool_Executing_SqlInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_tool_executing_sql = /** @type {((inputs?: Chat_Tool_Executing_SqlInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Tool_Executing_SqlInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Analysiere Daten")
	return /** @type {LocalizedString} */ ("Analyzing data")
});